<template>
  <div class="survey-point text-center" v-if="!answerPoint.pending">
    <template v-if="!hasUser">
      <div @click="onPoint">
        <img src="~@/assets/img/point-btn.png" alt="" width="343" />
      </div>
    </template>
    <template v-else>
      <split-box bg-color="#FFE4CC" line-color="rgba(0,0,0,0.15)" v-if="answerPoint.value && answerPoint.value.point">
        <template v-slot:top-content>
          <div class="text-small">
            <span>恭喜您抽中积分</span>
            <span v-if="enableNetManualAudit">，积分将在问卷发布者审核通过后发放</span>
          </div>
          <div>
            <span class="font-bold text-danger" style="color: #FF7700;font-size: 36px;">{{ surveyPoint.point }}</span>
            <span class="text-medium font-semibold" style="color: #FF7700;"> 积分</span>
          </div>
          <div class="point-btn" @click="toPoint">
            积分兑好礼
          </div>
          <template v-if="!hasUser">
            <el-button type="text" @click="onAward">领取奖励</el-button>
          </template>
        </template>
        <template v-slot:bottom-content>
          <div class=" text-small text-theme-black-450">
            <template v-if="enableNetManualAudit">
              问卷将在 {{ auditForRedEnvelopesAutoPassTime }} 小时内审核，审核通过后，积分将发放至调研工厂账户~</template
            >
            <template v-else> 积分已发放至调研工厂账户，请查收~</template>
          </div>
        </template>
      </split-box>
      <template v-else>
        <div class="bg-white p-4 shadow-theme rounded-small mt-4">
          <div class="text-small text-theme-black-450 text-center leading-18">
            <div>
              <img src="~@/assets/img/answer/point.png" alt="" width="132" />
            </div>
            <p>真遗憾，积分与您擦肩而过</p>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import SplitBox from '@/components/SplitBox'
import { createPopup } from '@/assets/js/factory'
import AwardPopup from '@/components/popup/AwardPopup'

export default {
  name: 'SurveyPoint',
  components: { SplitBox },
  computed: {
    hasUser() {
      return !!this.$bus.params.accountUserId
    },
    enableNetManualAudit() {
      const enableAuditForRedEnvelopes = this.$bus.survey.otherSetting.enableAuditForRedEnvelopes
      return this.$bus.enableNetManualAudit && !enableAuditForRedEnvelopes
    },
    answerPoint() {
      return this.$bus.answerPoint
    },
    surveyPoint() {
      return this.$bus.surveyPoint
    },
    auditForRedEnvelopesAutoPassTime() {
      return (this.$bus.survey.otherSetting.auditForRedEnvelopesAutoPassTime || 2) * 24
    }
  },
  methods: {
    onAward() {
      const url = this.$bus.getUrl(3)
      console.log(url)
      createPopup(AwardPopup, {
        isTest: !!this.$bus.params.isTest,
        url,
        needAuditFlag: !!this.enableNetManualAudit
      })
    },
    onPoint() {
      this.onAward()
    },
    toPoint() {
      window.open(`${process.env.VUE_APP_TASK_HALL}/pc/pointsMall`)
    }
  }
}
</script>

<style scoped>
.point-btn {
  width: 176px;
  line-height: 32px;
  background: #FF7700;
  font-family: PingFangSC-Regular;
  @apply my-0 mx-auto h-8 mt-2 font-normal text-medium text-white rounded-medium cursor-pointer;
}
</style>
